import React from 'react';
import CookieConsent from "react-cookie-consent";
import useWindowSize from './useWindowSize';
import { colors } from '../../../styles/customStyles';

export const CookieConsentAll = () => {

const size = useWindowSize();

    return (

            <><CookieConsent
            // overlay
            // enableDeclineButton
            flipButtons
            hideOnAccept={true}
            // visible={accept ? "byCookieValue": "show"}
            location={size?.width>600 ? "bottom" :"top"}
            style={{
                background: "#000",
                textAlign: "left",
                // marginLeft: 10
            }}
            buttonStyle={{
                color: colors.black,
                background: colors.bright,
                fontSize: "12px",
                borderRadius:'5px',
                padding:'10px'
            }}
            // declineButtonStyle={{
            //     color: "#000",
            //     background: "#fff",
            //     fontSize: "12px"
            // }}
            buttonText="I UNDERSTAND"
            // declineButtonText="Change options"
            expires={365} //how often the banner is shown
        ><p style={{color:colors.light}}>This website uses cookies to ensure you get the best experience on our website.<br/><a style={{ textDecoration: 'underline', color:colors.bright, cursor:'pointer' }} href="/cookie-policy">See our Cookie Policy</a>.
        </p>
        </CookieConsent>
  </> 
    )
}
